
<div :class="classes(n(), isLiteapp ? n('--liteapp') : '')">
  <!-- 可滚动区域（header + content）- liteapp 环境使用 scroll-view -->
  <scroll-view
    v-if="isLiteapp"
    ref="scrollableRef"
    :class="classes(n('scrollable'))"
    scroll-y
    :show-scrollbar="false"
    @scroll="handleScroll"
  >
    <!-- 顶部区域 -->
    <div :class="classes(n('header'))">
      <!-- 图标区域 -->
      <div
        v-if="icon || $slots['header-icon']"
        :class="classes(n('icon'), icon ? n(`icon--${icon}`) : '')"
      >
        <template v-if="$slots['header-icon']">
          <slot name="header-icon" />
        </template>
        <component
          :is="iconConfig.component"
          v-else-if="iconConfig"
          width="128"
          :color="iconConfig.color"
        />
      </div>

      <!-- 标题区域 -->
      <h2
        v-if="title || $slots['header-title']"
        :class="classes(n('title'))"
      >
        <slot name="header-title">
          {{ title }}
        </slot>
      </h2>

      <!-- 描述区域 -->
      <div
        v-if="description || $slots['header-description']"
        :class="classes(n('description'))"
      >
        <slot name="header-description">
          {{ description }}
        </slot>
      </div>
    </div>

    <!-- 中间内容区域 -->
    <div
      v-if="$slots.content"
      :class="classes(n('content'))"
    >
      <slot name="content" />
    </div>
  </scroll-view>

  <!-- 可滚动区域（header + content）- H5 环境使用原生 div -->
  <div
    v-else
    ref="scrollableRef"
    :class="classes(n('scrollable'))"
    @scroll="handleScroll"
  >
    <!-- 顶部区域 -->
    <div :class="classes(n('header'))">
      <!-- 图标区域 -->
      <div
        v-if="icon || $slots['header-icon']"
        :class="classes(n('icon'), icon ? n(`icon--${icon}`) : '')"
      >
        <template v-if="$slots['header-icon']">
          <slot name="header-icon" />
        </template>
        <component
          :is="iconConfig.component"
          v-else-if="iconConfig"
          width="128"
          :color="iconConfig.color"
        />
      </div>

      <!-- 标题区域 -->
      <h2
        v-if="title || $slots['header-title']"
        :class="classes(n('title'))"
      >
        <slot name="header-title">
          {{ title }}
        </slot>
      </h2>

      <!-- 描述区域 -->
      <div
        v-if="description || $slots['header-description']"
        :class="classes(n('description'))"
      >
        <slot name="header-description">
          {{ description }}
        </slot>
      </div>
    </div>

    <!-- 中间内容区域 -->
    <div
      v-if="$slots.content"
      :class="classes(n('content'))"
    >
      <slot name="content" />
    </div>
  </div>

  <!-- 底部区域（固定在底部） -->
  <div
    v-if="hasFooter"
    :class="classes(n('footer'), hasScrollableContent ? n('footer--scrollable') : '')"
  >
    <!-- 渐变蒙层 - 提示上方内容可滚动 -->
    <div
      v-if="showGradient"
      :class="classes(n('footer-gradient'))"
    />

    <!-- 用户协议区域 -->
    <div
      v-if="$slots['footer-top']"
      :class="classes(n('footer-top'))"
    >
      <slot name="footer-top" />
    </div>

    <!-- 操作按钮区域 -->
    <div
      v-if="$slots['footer-actions']"
      :class="classes(n('actions'))"
    >
      <slot name="footer-actions" />
    </div>

    <!-- 底部信息区域容器 -->
    <div :class="classes(n('footer-info'))">
      <!-- 额外信息区域 -->
      <div
        v-if="$slots['footer-extra']"
        :class="classes(n('footer-extra'))"
      >
        <slot name="footer-extra" />
      </div>

      <!-- 底部固定区域 -->
      <div
        v-if="$slots['footer-bottom']"
        :class="classes(n('footer-bottom'))"
      >
        <slot name="footer-bottom" />
      </div>
    </div>
  </div>
</div>
